// extracted by mini-css-extract-plugin
export var textInput = "_lf-0";